export default __webpack_public_path__ + "static/media/image_banner_user.b08da68e.png";